
import {
    getFirestore,
    collection,
    doc,
    query,
    where,
    orderBy,
    startAfter,
    limit,
    getDoc,
    getDocs,
    updateDoc,
    setDoc,
    runTransaction,
    addDoc,
  } from "firebase/firestore";

import { db } from "../apis/auth";



// export async function getAllTickets(zone = 0, ward = 0, deviceType = -1, states = [0,1,2,3]) {

    // var queryObj = query(
    //     collection(db(), 'tickets'));
    //     if (zone !== 0){
    //         queryObj = query(
    //             queryObj,
    //             where("zn", "==", zone));

    //         if (ward !== 0){
    //             queryObj = query(
    //                 queryObj,
    //                 where("wd", "==", ward));
    //         }
    //     }
    //     if (deviceType !== -1) {
    //         queryObj = query(
    //             queryObj,
    //             where("dt", "==", deviceType));
    //     }
    //     queryObj = query(
    //         queryObj,
    //         where("st", "in", states));
        
//     var data = [];
//     // debugger;
//     await getDocs(queryObj).then((querySnapshot) => {
        
//         querySnapshot.forEach((doc) => {
//             console.log("ReportManager : GetDailyReport() users docs : ", JSON.stringify(doc.data()));
//             data.push(doc.data());
//         });
        
//     }).catch((error)=>{
//         console.log(`====> Error fetch : ${error}`);
//         return Promise.reject(error);
//     });
//     // debugger;
//     return Promise.resolve(data);
// }


export async function getSLCLine(slcId) {
  const collectionRef = collection(db(), "slc_line");
  var queryObj = query(collectionRef, where("slc_id", "==", slcId));
  var data = {};
  await getDocs(queryObj).then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
          console.log("ReportManager : GetDailyReport() users docs : ", JSON.stringify(doc.data()));
            var resData = doc.data();
            if (resData.path != undefined && resData.path != null && resData.path != "") {
                resData.path = JSON.parse(resData.path);
            }
            
          data = {
            docId:doc.id,
            data:resData
          };
      });
      
  }).catch((error)=>{
      console.log(`====> Error fetch : ${error}`);
      return Promise.reject(error);
  });
  // debugger;
  return Promise.resolve(data);
  
}

export async function updateSLCLine(slcLineArg) {
    var slcLine = JSON.parse(JSON.stringify(slcLineArg));
    if (slcLine.data.path != undefined && slcLine.data.path != null && slcLine.data.path != "") {
        slcLine.data.path = JSON.stringify(slcLine.data.path);
    }
     const collectionRef = collection(db(), "slc_line");
    if (slcLine?.docId === undefined) {
        await addDoc(collectionRef, slcLine.data).catch((e) => {
            return Promise.error(e);
        });
        // await addDoc(collectionRef, {"path":[],"slc_id":"SC3-XYZ-ZDefault-W5-S5"}).catch((e) => {
        //     return Promise.error(e);
        // });
    } else {
        await setDoc(doc(collectionRef, slcLine.docId), slcLine.data).catch((e) => {
            return Promise.error(e);
        });
    }
    
    return Promise.resolve(true);
    
}

// export async function updatePoles(data) {
//     // const collectionRef = collection(db(), "poles");

//     try {
//         await runTransaction(db(), async (transaction) => {
//             for (var poleRef in data) {
//                 const sfDocRef = doc(db(), "poles", poleRef);
//                 transaction.update(sfDocRef, data[poleRef]);
//             }
//             // const sfDoc = await transaction.get(sfDocRef);
//             // if (!sfDoc.exists()) {
//             //     throw "Document does not exist!";
//             // }
//         });
//         console.log("Transaction successfully committed!");
//         return Promise.resolve(true);
//       } catch (e) {
//         console.log("Transaction failed: ", e);
//         return Promise.error(e);
//       }
// }